import React from 'react';
import { RefreshCcw } from 'lucide-react';

const Button = ({ 
  children, 
  isLoading = false, 
  disabled = false, 
  variant = 'default', // 'default' o 'unstyled'
  className = '', 
  iconRight,
  iconLeft,
  spinnerSize = 18,
  ...props 
}) => {
  // El botón estará deshabilitado si está cargando o si se deshabilitó explícitamente
  const isDisabled = isLoading || disabled;

  // Si es variant default, inyectamos nuestras clases de diseño consistentes
  const baseClasses = variant === 'default' 
    ? 'relative flex items-center justify-center gap-2 font-black uppercase tracking-widest transition-all active:scale-[0.98]' 
    : 'relative flex items-center justify-center transition-all active:scale-[0.98] disabled:active:scale-100';
    
  // Estilo al estar deshabilitado
  const disabledClasses = isDisabled ? 'opacity-70 cursor-not-allowed pointer-events-none' : '';

  return (
    <button
      disabled={isDisabled}
      aria-busy={isLoading}
      className={`${baseClasses} ${disabledClasses} ${className}`}
      {...props}
    >
      {/* Si está cargando, mostramos el spinner; si no, mostramos el icono izquierdo si existe */}
      {isLoading ? (
        <span className="inline-flex items-center justify-center">
          <RefreshCcw className="animate-spin" size={spinnerSize} />
        </span>
      ) : (
        iconLeft && iconLeft
      )}

      {/* Contenido del botón (Texto) */}
      <span>{children}</span>

      {/* Ícono a la derecha, si existe y no está cargando sobreponiéndolo */}
      {iconRight && !isLoading && iconRight}
    </button>
  );
};

export default Button;
